import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Repeater from '@Utils/Repeater';
import { CardDisplay } from '../utils/CardDisplay';
import Card from '../utils/Card';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { FormattedMessage } from 'react-intl';
import { Row } from 'reactstrap';
import { defaultMessages } from '@I18n/default';
import { TYPES } from '@Types';
import { container } from '@Container';
import { VersionsAction } from '@Redux/actions';
import { Version, VersionGame } from '@Models';
import { change, InjectedFormProps, reduxForm } from 'redux-form';
import validate, { CreateDraftParams } from '@Components/draft/create/DraftValidate';
import { GameView } from '@Selectors/builder/myArmyList/common/ArmyListView';

interface Props {
  onSubmit: () => void
}

const Form: React.FC<FormProps & InjectedFormProps<CreateDraftParams, FormProps>> =  (
  { versions, selectVersion, onSubmit, load }
) => {
  useEffect(() => {
    load();
  }, []);
  const [game, setGame] = useState<VersionGame | null>(null);

  const allGames = [
    { id: VersionGame.NinthAge, name: 'Ninth Age' } satisfies GameView as GameView,
    { id: VersionGame.WarhammerBattle, name: 'Warhammer Battle' } satisfies GameView as GameView,
    { id: VersionGame.EssenceOfWar, name: 'Essence of War' } satisfies GameView as GameView,
    { id: VersionGame.TheOldWorld, name: 'The Old World' } satisfies GameView as GameView,
  ];

  const onSelect = (game: VersionGame, versionId: number) => {
    selectVersion(game, versionId);
    onSubmit();
  }

  return (
    <form>
      <h1 className="text-center">
        <FormattedMessage
          {...defaultMessages.toolPairingSelectGame}
        />
      </h1>
      <Row className="justify-content-md-center card-armies">
        {!game && (<Repeater data={allGames} indexPrefix="game">
          {(item: GameView) => (
            <Card
              display={CardDisplay.TEXT}
              text={item.name}
              selectable={true}
              select={() => setGame(item.id)}
            />
          )}
        </Repeater>)}

        {game && (<Repeater data={versions.filter((v: Version) => v.game === game)} indexPrefix="version">
          {(version: Version) => (
            <Card
              display={CardDisplay.TEXT}
              text={version.name}
              selectable={true}
              select={() => onSelect(version.game, version.id)}
            />
          )}
        </Repeater>)}
      </Row>
    </form>
  );
};

const SelectGameForm = reduxForm<CreateDraftParams, FormProps>({
  form: 'create_draft',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(Form);

const mapStateToProps = (state: AppState) => ({
  versions: state.versions.entity ?? [],
})

const mapDispatchToProps = (dispatch: Dispatch) => {
  const versionsAction = container.get<VersionsAction>(TYPES.Actions.VersionsAction);

  return {
    load: () => dispatch(versionsAction.fetchData()),
    selectVersion: (game: VersionGame, versionId: number) => {
      dispatch(change('create_draft', 'versionId', versionId));
      dispatch(change('create_draft', 'game', game));
    }
  }
}

type FormProps = Props &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

export default connect(mapStateToProps, mapDispatchToProps)(SelectGameForm);
